import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBuilder } from '../components/TrustBuilder';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AdaptabilitySection } from '../components/AdaptabilitySection';
import { ResultsGrid } from '../components/ResultsGrid';
import { AuthorityBlock } from '../components/AuthorityBlock';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <main className="min-h-screen bg-stark-white overflow-x-hidden" data-id="element-311">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-312" />
      <HeroSection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-313" />
      <TrustBuilder data-id="element-314" />
      <ProblemSection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-315" />
      <SolutionSection data-id="element-316" />
      <AdaptabilitySection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-317" />
      <ResultsGrid data-id="element-318" />
      <AuthorityBlock data-id="element-319" />
      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-320" />
      <Footer data-id="element-321" />

      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-322" />
    </main>;
}